import { Icon } from "materia"
import { usePDFContext } from "../../providers"
import s from "./Navigation.module.scss"

export const Navigation = () => {
  const { currentPageNumber, numberOfPagesRef, navigateToPage } =
    usePDFContext()

  if (numberOfPagesRef.current === 1) return null

  return (
    <div className={s.navigation}>
      <button
        className={s.navigation__button}
        onClick={() => navigateToPage(currentPageNumber - 1)}
        disabled={currentPageNumber <= 1}
        title="Navigate to previous page"
      >
        <Icon icon="Arrow" size="large" rotate={180} />
      </button>

      <button
        className={s.navigation__button}
        onClick={() => navigateToPage(currentPageNumber + 1)}
        disabled={currentPageNumber >= numberOfPagesRef.current}
        title="Navigate to next page"
      >
        <Icon icon="Arrow" size="large" />
      </button>
    </div>
  )
}
